import type React from "react";

export const ScubaIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 480.318 480.318"
      xmlSpace="preserve"
      {...restProps}
    >
      <title>Scuba icon</title>
      <g>
        <path
          d="M459.001 97.095v48.194c0 4.468-3.658 8.079-8.125 7.999-5.51-.099-14.987.107-36.86.027-3.273-.012-6.195-2.024-7.413-5.062-4.438-11.071-10.435-21.969-17.959-32.014-1.052-1.404-1.643-3.1-1.643-4.854v-14.4c0-4.536 3.763-8.158 8.296-7.994 13.908.502 41.172.671 55.37.112 4.545-.18 8.334 3.443 8.334 7.992zM450.884 263.291c4.465-.076 8.117 3.534 8.117 7.999v20c0 82.968-61.928 151.748-141.989 162.528-5.849.788-10.556-4.778-8.711-10.384 5.479-16.65 4.858-34.777-1.715-50.97-1.899-4.678.975-9.889 5.931-10.848 42.821-8.287 74.51-46.267 74.494-89.189a7.882 7.882 0 0 1 1.574-4.742c4.947-6.58 9.348-13.673 12.639-20.055a8.028 8.028 0 0 1 7.101-4.363c26.134-.095 36.753.123 42.559.024zM281.945 135.953H120.197c-36.926 0-67.07 29.526-67.195 65.819-.127 36.629 29.411 66.291 66.055 66.291 14.397 0 28.07-4.543 39.542-13.14 24.63-18.458 59.121-18.449 83.873.05 11.457 8.563 25.107 13.09 39.474 13.09 35.92 0 65.55-29.205 66.049-65.103.513-36.975-29.172-67.007-66.05-67.007z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M365.251 113.53c-21.79-22.08-50.45-34.24-80.69-34.24h-166.95C52.981 79.29.221 134.15.001 201.58c-.11 34.09 12.73 65.82 36.17 89.33 41.119 41.27 104.649 45.322 150.19 9.23 8.45-6.7 19.86-6.66 28.4.09 45.403 35.911 110.122 32.637 152.06-11.56 46.754-49.308 44.882-128.086-1.57-175.14zm-83.306 170.533c-17.846 0-34.809-5.627-49.053-16.273-19.096-14.273-45.702-14.298-64.699-.063-32.279 24.189-78.088 21.499-107.27-7.785-15.502-15.556-23.998-36.234-23.921-58.227.156-45.084 37.477-81.763 83.195-81.763h161.749c45.745 0 82.686 37.26 82.047 83.23-.621 44.599-37.427 80.881-82.048 80.881z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M231.635 343.324c-17.648 9.429-44.29 9.402-62.066-.071-5.793-3.087-5.578-11.514.376-14.277 9.26-4.298 18.085-9.747 26.355-16.296 2.55-2.02 5.9-1.98 8.53.1 8.406 6.65 17.298 12.065 26.385 16.269 5.959 2.756 6.211 11.181.42 14.275zM450.941 247.29h-30.539c-5.189 0-9.035-4.871-7.765-9.903 4.752-18.819 5.713-38.825 2.444-58.743-.803-4.894 2.919-9.354 7.879-9.354h27.991c38.613 0 39.698 78-.01 78zM451.001 73.29h-56c-12.13 0-22-9.87-22-22v-26c0-12.13 9.87-22 22-22h56c12.13 0 22 9.87 22 22v26c0 12.13-9.87 22-22 22zM296.001 420.29c0 25.24-16.24 47.43-40.41 55.23-23.462 7.566-45.651-14.608-38.22-38.15 3.54-11.17 3.54-22.98 0-34.15-7.43-23.54 14.708-45.727 38.21-38.16 24.18 7.78 40.42 29.98 40.42 55.23z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
};
